export const config = {
    //apiUrl: "http://localhost:8433",
    apiUrl: "https://api.trivia.veertig.xyz:8433",
    googleMapKey: "AIzaSyBjZBtThl8wf9N9a2eQpxW1ePnrxt5tcCQ",
    rtDatabasePrefix: "production/userReadable"
};


// WEBPACK FOOTER //
// ./src/helpers/apiConfig.js